import React, { Component } from 'react'
import AdItem from './../Carousel/components/AdItem'
import Link from './../Carousel/components/Link'
import Image from './../Carousel/components/Image'
import Info from './../Carousel/components/Info'
import InfoTitle from './../Carousel/components/InfoTitle'
import Price from './../Carousel/components/Price'
import { clickTracking } from '../utils/tracking'
import './styles/index.css'

import AdItemPlaceholder from './adItemPlaceHolder';


class Grid extends Component {

  handleClick(ad, adPosition, gallery_id) {
    clickTracking(
      this.props.object_name || "missing",
      "recommendation",
      {
        custom_tag: this.props.custom_tag || "missing",
        list_id: ad.list_id,
        ad_position: adPosition,
        gallery_id: gallery_id
      }
    );
  }

  render() {
    const { galleryResponse } = this.props

    if (!galleryResponse.content.length) return null

    return (
    
      <div className="grid-container">
      {
        galleryResponse.content.map((ad, i) => {
          return (
            <div className="grid-item" key={i}>
              <AdItem orientation={'horizontal'}>
                <Link href={ad.ad_url} onClick={() => this.handleClick(ad, i, galleryResponse.gallery_id)}>
                  <Image orientation={'horizontal'}>
                    <img src={(ad.image_url)} alt={ad.subject} />
                  </Image>
                  <Info orientation={'horizontal'}>
                    <InfoTitle orientation={'horizontal'}>{ad.subject}</InfoTitle>
                    <Price orientation={'horizontal'}>{ad.price}</Price>
                  </Info>
                </Link>
              </AdItem>
            </div>
          )
        })
      }
    </div>

        
    )
  }
}

const RenderPlaceHolderIfNoData = (props) => (
    !props.galleryResponse.content.length ?
      <div className="grid-container">
        <AdItemPlaceholder />
        <AdItemPlaceholder />
        <AdItemPlaceholder />
        <AdItemPlaceholder />
        <AdItemPlaceholder />
        <AdItemPlaceholder />
        <AdItemPlaceholder />
        <AdItemPlaceholder />
        <AdItemPlaceholder />
        <AdItemPlaceholder />
        <AdItemPlaceholder />
        <AdItemPlaceholder />
      </div>
    : <Grid {...props} />
);

export default (RenderPlaceHolderIfNoData)


// WEBPACK FOOTER //
// ./src/node_modules/components/Pimper/Grid/index.js